// native
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

// service
import { ApiService } from './api.service';

// model
import { IDevSettingsConfig } from '../../models';

// constants
import { API_DEV_MODE_CONFIG_PATH } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class DevSettingsService {
  constructor(
    private apiService: ApiService
  ) { }

  getDevModeConfig(): Observable<IDevSettingsConfig> {
    return this.apiService.get(API_DEV_MODE_CONFIG_PATH).pipe(map(res => res as IDevSettingsConfig));
  }

  updateDevModeConfig(body: Partial<IDevSettingsConfig>): Observable<IDevSettingsConfig> {
    return this.apiService.put(API_DEV_MODE_CONFIG_PATH, body).pipe(map(res => res as IDevSettingsConfig));
  }
}

